import {store as AppStore} from '../store/store';
import {fetchOccasionBrands} from '../store/slices/occasion_brands_slice';

export async function occasionBrandsLoader(store: typeof AppStore) {
    const result = await store.dispatch(fetchOccasionBrands());
    return result;
}
